import Image from '@/components/image';

const TestimonialCard = ({ info, locale }) => {
  return (
    <div className='rounded-lg border border-[#DDDDDD] px-4 py-3.5 sm:px-5 sm:py-4.25 md:px-8 md:py-6'>
      <div className='h-15 sm:h-17 md:h-20'>
        <q className='line-clamp-3 max-sm:text-xs sm:text-sm'>
          {info?.[`review-${locale}`] || ''}
        </q>
      </div>

      <div className='mt-1.5 flex gap-5 md:mt-3.5'>
        <Image
          src={info?.[`author-img`]}
          alt={info?.[`author-name-${locale}`]}
          className='size-9 rounded-full md:size-12'
        />
        <div>
          <p className='mb-1 text-sm font-semibold max-sm:text-xs'>
            {info?.[`author-name-${locale}`] || ''}
          </p>
          <p className='line-clamp-1 text-[13px] max-sm:text-[11px]'>
            {info?.[`author-title-${locale}`] || ''}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
